export default __webpack_public_path__ + "static/media/smile.7ccc3c5f.svg";